var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / chatting / comment-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99935 18.17L10.0717 14.9998H16.666C17.5865 14.9998 18.3327 14.2536 18.3327 13.3332V3.33317C18.3327 2.4127 17.5865 1.6665 16.666 1.6665H3.33268C2.41221 1.6665 1.66602 2.4127 1.66602 3.33317V13.3332C1.66602 14.2536 2.41221 14.9998 3.33268 14.9998H4.99935V18.17ZM9.59368 13.3332L6.66602 15.163V13.3332H3.33268V3.33317H16.666V13.3332H9.59368ZM5.83268 10.8332V9.1665H11.666V10.8332H5.83268ZM5.83268 5.83317V7.49984H13.3327V5.83317H5.83268Z",
    fill: "black",
    fillOpacity: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentText);
export default __webpack_public_path__ + "static/media/comment-text.c7b51dbb487614323b8b81d69eebeb5a.svg";
export { ForwardRef as ReactComponent };